module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_2_open-2c31dc09.png";